<template>
    <div class="container">
      <div class="toy">
      <a href="/">
      <img src="../../assets/home.png" class="icon"/>
      </a>
    </div>
      <div class="title">问题： {{ qadata.title }}</div>
      <div class="keyword"><strong>关键词：</strong> {{ qadata.keywords }}</div>
      <div class="model"><strong>适用机型：</strong> {{ qadata.Models }}</div>
      <div class="model"><strong>问题解答：</strong></div>
      <div class="content" v-html="qadata.contents"></div>
    </div>
   
  </template>
  <script>
  import Vue from 'vue'
  export default {
        name: 'showContent',
       
        data(){
                return{			
                    pdfurl :'',
                    qadata:{},
                    qaid:''
                }  	 
          },
      created(){		
              this.qaid = this.$route.query.qaid
              this.getDatainfo()
          },
      methods:{
        getDatainfo(){
            let that = this
            console.log('get list')
            Vue.axios.get('https://t3.lenovoimage.com/api/web2/userqainfo?qaid=' + this.qaid)
            .then(function (res) {

              that.qadata = res.data.Data[0];
              console.log("qadata:",that.qadata);
             

            })
            .catch(function (error) {
              console.log(error);
            });                   
        }
      }
        }
  </script>
  
  <style scoped>
  .container {
    font-size: 14px;
    text-align: left;
    margin-left:20px;
    margin-right: 20px;
    margin:0 auto;
    width: 750 rpx;
    word-wrap:break-word;
    word-break:normal; 

    .title {
      font-weight: 800;
      text-align: center;
      font-size:14px;
      padding-top: 10px;
    }
    .keyword {
      font-size:12px;
      padding: 10px;
    }
    .model {
      font-size:12px;
      padding: 10px;
    }
    .content {
      font-size: 12px;
    }
  }
  </style>